import { render, staticRenderFns } from "./CloudManager.vue?vue&type=template&id=2a60b88d&"
import script from "./CloudManager.vue?vue&type=script&lang=js&"
export * from "./CloudManager.vue?vue&type=script&lang=js&"
import style0 from "./CloudManager.vue?vue&type=style&index=0&id=2a60b88d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports